import { gql } from 'apollo-boost';

export const SEND_PUSH_CAMPAIGN_TEST = gql`
    mutation($data: SendPushCampaignTestInput!) {
        sendPushCampaignTest(data: $data) {
            ... on SendPushCampaignTestSuccess {
                success
                message
            }
            ... on UserNotFound {
                message
            }
            ... on InternalServerError {
                message
            }
        }
    }
`;
